import '@rainbow-me/rainbowkit/styles.css';
import React from 'react';
import Head from 'next/head';
import OwnerDashboardComponent from '@components/Owner/dashboard';
import { withOwnerLayout } from '@components/Layouts/withOwnerLayout';
import { useOwnerPageGuard } from '@hooks/useOwnerPageGuard';

const OwnerDashboardPage = () => {
	useOwnerPageGuard();

	return (
		<>
			<Head>
				<title>Dashboard</title>
			</Head>
			<OwnerDashboardComponent />
		</>
	);
};

OwnerDashboardPage.getLayout = withOwnerLayout;

export default OwnerDashboardPage;
